import React, { useRef } from "react";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import isTouch from "../../../../utils/checkTouchDevice.js";
import { usePopupContextMenu } from "../../../../contexts/popupContextMenuContext/popupContextMenuContext.js";
import { useLightBox } from "../../../../contexts/lightBoxContext/lightBoxContext.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";

const EnterControl = ({
  setHover,
  children,
  itemId,
  externalHandleClick,
  style,
}) => {
  const { setLightBox } = useLightBox();
  const { getFileSelected, toggleFileSelect } = useMailView();
  const { getFilesData } = useMail();
  const { mobileCondition } = useMediaQueries();
  const { setPosition } = usePopupContextMenu() || { setPosition: null };
  let holdTouch = false;

  const handleClick = (id) => {
    const fileType = getFilesData()[itemId].Type;
    setLightBox(fileType, id);
  };
  const containerRef = useRef();

  const handleContextClick = (e) => {
    e.preventDefault();
    if (!mobileCondition) {
      setPosition(e, containerRef.current, itemId);
    }
  };

  return (
    <div
      className={`grid-item${getFileSelected(itemId) ? " selected" : ""}`}
      onClick={() =>
        externalHandleClick ? externalHandleClick(itemId) : handleClick(itemId)
      }
      style={style}
      ref={containerRef}
      onContextMenu={(e) => handleContextClick(e)}
      onMouseEnter={() => {
        containerRef.current.parentElement.classList.add("hovered");
        return isTouch() || mobileCondition ? null : setHover(true);
      }}
      onTouchStart={() => {
        holdTouch = true;
        setTimeout(() => {
          holdTouch ? toggleFileSelect(itemId) : setHover(false);
        }, 1000);
      }}
      onTouchEnd={() => {
        holdTouch = false;
      }}
      onMouseLeave={() => {
        containerRef.current.parentElement.classList.remove("hovered");
        // setContextMenu({ isOpen: false, position: null });
        setHover(false);
      }}
    >
      {children}
    </div>
  );
};

export default EnterControl;
